<!-- eslint-disable max-len -->
<template>
  <div
    id="modal-success-validation-DNS"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="modalSuccessValidationDNS"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div v-show="deafultModal" class="modal-content">
        <div class="modal-header">
          <p class="w-100 text-start fs-5 fw-600 m-0">Tudo Certo!</p>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>

        <div class="modal-body">
          <div class="mb-5 text-center">
            <img
              width="210px"
              src="@/assets/images/modal-Sucesso.jpg"
              alt="waiting-room"
            />
          </div>
          <div class="text-start">
            <p class="w-100 text-start fs-6 fw-600 m-0">
              Seu domínio foi validado com sucesso!
            </p>

            <p class="w-100 text-start fs-6 m-0">
              Deseja instalar seu certificado agora?
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <div class="d-flex justify-content-end col-12 col-md-4">
            <button class="btn btn-secondary col-12" @click="changeModal">
              <span>Instalar mais tarde</span>
            </button>
          </div>

          <div class="d-flex justify-content-end col-12 col-md-4">
            <button class="btn btn-primary col-12" @click="navidateToGuide">
              <span>Instalar Agora</span>
            </button>
          </div>
        </div>
      </div>

      <div v-show="!deafultModal" class="modal-content">
        <div class="modal-header">
          <p class="w-100 text-start fs-5 fw-600 m-0">Sem tempo agora?</p>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>

        <div class="modal-body">
          <div class="mb-5 text-center">
            <img
              width="210px"
              src="@/assets/images/Sala_de_espera.svg"
              alt="Menina com xícara de café com um desenho de coreção"
            />
          </div>
          <div class="text-start">
            <p class="w-100 text-start fs-6 m-0">
              Sem problemas! Já te enviamos um e-mail com as instruções para
              você instalar mais tarde!
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <div class="d-flex justify-content-end col-12 col-md-4">
            <button class="btn btn-primary col-12" @click="hideModal">
              <span>Fechar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { Modal } from 'bootstrap'

  export default defineComponent({
    data() {
      return {
        modal: null as null | Modal,
        deafultModal: true,
      }
    },
    mounted() {
      this.modal = new Modal(
        document.getElementById('modal-success-validation-DNS') as HTMLElement,
        // eslint-disable-next-line comma-dangle
        {},
      )
    },
    methods: {
      navidateToGuide() {
        this.hideModal()
        this.$router.push({ path: '/ssl-certificate/installation-guide-ssl' })
      },
      changeModal() {
        this.deafultModal = false
      },
      showModal() {
        this.modal?.show()
      },
      hideModal() {
        this.modal?.hide()
      },
      setModalDefault() {
        this.deafultModal = true
      },
    },
  })
</script>
